import { render, staticRenderFns } from "./IGChannelDetail.vue?vue&type=template&id=ea10acd8&scoped=true"
import script from "./IGChannelDetail.vue?vue&type=script&lang=js"
export * from "./IGChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./IGChannelDetail.vue?vue&type=style&index=0&id=ea10acd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea10acd8",
  null
  
)

export default component.exports